import { makeAutoObservable } from "mobx";
import { PAsapFulfillmentTime } from "./PAsapFulfillmentTime";
import { PTodayFulfillmentTime } from "./PTodayFulfillmentTime";
import { PInFutureFulfillmentTime } from "./PInFutureFulfillmentTime";
export class POnlineFulfillmentTime {
    constructor(props) {
        this.fulfillmentInstructions = props.fulfillmentInstructions;
        this.asapOption = new PAsapFulfillmentTime({
            restaurant: props.restaurant,
            fulfillmentInstructions: props.fulfillmentInstructions,
        });
        this.todayOption = new PTodayFulfillmentTime({
            restaurant: props.restaurant,
            fulfillmentInstructions: props.fulfillmentInstructions,
            purchaseOrder: props.purchaseOrder,
        });
        this.inFutureOption = new PInFutureFulfillmentTime({
            restaurant: props.restaurant,
            fulfillmentInstructions: props.fulfillmentInstructions,
            purchaseOrder: props.purchaseOrder,
        });
        makeAutoObservable(this);
    }
    get domain() {
        return this.fulfillmentInstructions.fulfillmentTime;
    }
    // TODO: take into condition deliveryTimesStatus
    // purs: client/purs/src/Restaumatic/Site/Components/Delivery.purs:99
    get isEditable() {
        return this.options.length > 0;
    }
    get activeOption() {
        for (const option of this.options) {
            if (option.isActive)
                return option;
        }
        return null;
    }
    get optionValue() {
        var _a, _b;
        return (_b = (_a = this.activeOption) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : null;
    }
    get hourValue() {
        return this.domain !== null && this.domain.type === "OnTime"
            ? this.domain.date.fullHour
            : null;
    }
    get dateValue() {
        return this.domain !== null && this.domain.type === "OnTime"
            ? this.domain.date.fullDate
            : null;
    }
    get optionCombinations() {
        return [
            [this.asapOption, this.inFutureOption],
            [this.asapOption, this.todayOption],
            [this.inFutureOption],
            [this.todayOption],
            [this.asapOption],
        ];
    }
    get options() {
        const availableCombination = this.optionCombinations.find((combination) => {
            let isAvailable = true;
            for (const option of combination) {
                if (!option.isAvailable)
                    isAvailable = false;
            }
            return isAvailable;
        });
        return availableCombination !== null && availableCombination !== void 0 ? availableCombination : [];
    }
    // FIXME: remove field controllers - for now it is required to see the related values change in the UI
    setOption(value, dateController, hourController) {
        var _a, _b, _c;
        if (value === this.optionValue) {
            return;
        }
        switch (value) {
            case "ASAP": {
                this.asapOption.setDefaultValue();
                break;
            }
            case "Today": {
                this.todayOption.setDefaultValue();
                hourController.onChange((_a = this.hourValue) !== null && _a !== void 0 ? _a : "");
                break;
            }
            case "InFuture": {
                this.inFutureOption.setDefaultValue();
                dateController.onChange((_b = this.dateValue) !== null && _b !== void 0 ? _b : "");
                hourController.onChange((_c = this.hourValue) !== null && _c !== void 0 ? _c : "");
                break;
            }
            default:
                this.unassignedValue(value);
        }
    }
    unassignedValue(x) {
        throw new Error(`Fulfillment time option ${x} doesn't have default value`);
    }
    // FIXME: remove hour field controller - for now it is required to see the related value change in the UI
    setDate(date, hourController) {
        var _a, _b;
        (_a = this.activeOption) === null || _a === void 0 ? void 0 : _a.setDate(date);
        hourController.onChange((_b = this.hourValue) !== null && _b !== void 0 ? _b : "");
    }
    setHour(hour) {
        var _a;
        (_a = this.activeOption) === null || _a === void 0 ? void 0 : _a.setHour(hour);
    }
    // TODO: set proper fulfillment time status, logic:
    // client/purs/src/Restaumatic/Site/Components/Checkout/View.purs:49
    // client/purs/src/Restaumatic/Site/Components/Cart/DishesCalculator.purs
    get fulfillmentTimeStatus() {
        return { type: "AllAvailable" };
    }
}
